jQuery(document).ready(function () {
	window.onresize = function (event) {
		jQuery(".map > iframe").attr("width", jQuery(".map").width());
	};
	jQuery(".map > iframe").attr("width", jQuery(".map").width());
});
